import r from '../Utils/fetch';

const w: any = window;
const endPoint = `${w.API_BILLING_URL}`;

export interface UsageFilter {
	billingAccountId: string;
	date: string;
}

export interface UsageByDate {
	groupDate: string;
	totalInsertedRows: number;
	totalDeletedRows: number;
	totalActiveRows: number;
}

export interface UsageRow {
	projectFolderId: string;
	project: string;
	accountId: string;
	sku: string;
	nbrOfInsertedRows: number;
	nbrOfActiveRows: number;
}

export interface UsagePeriods {
	currentPeriodStart?: string;
	currentPeriodEnd?: string;
	LastPeriodStart?: string;
	lastPeriodEnd?: string;
	currentMonthStart?: string;
	currentMonthEnd?: string;
	lastMonthStart?: string;
	lastMonthEnd?: string;
}

export interface UsageResponse {
	byDate: UsageByDate[];
	usageRows: UsageRow[];
	totalInsertedRows: number;
	totalDeletedRows: number;
	totalActivedRows: number;
	periods: UsagePeriods;
}

export const getUsage = (
	filter: UsageFilter,
	groupBy: string[] = ['sku', 'day']
): Promise<UsageResponse> => {
	const params = new URLSearchParams();
	params.append('filter', JSON.stringify(filter));
	params.append('groupBy', JSON.stringify(groupBy));
	return r({ url: `${endPoint}/v1/admin/usage?${params.toString()}`, method: 'GET' });
};

export interface ConnectorAccountSummary {
	projectFolderId: string;
	projectName: string;
	sku: string;
	accountId: string;
	accountName: string;
	nbrAdAccounts: number;
	status: number;
}

export interface DailyRows {
	date: string;
	totalActiveRows: number;
}

export interface ConnectorAccountsSummaryResponse {
	accounts: ConnectorAccountSummary[];
	totalAdAccounts: number;
	rowsByDay: DailyRows[];
	totalActiveRowsLast30d: number;
}

// Liste les connector_accounts d'un BA avec leur nbr_ad_accounts denormalise.
// Endpoint dedie : GET /v1/admin/billing-accounts/:id/connector-accounts.
export const getConnectorAccountsSummary = (
	billingAccountId: string
): Promise<ConnectorAccountsSummaryResponse> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/connector-accounts`,
		method: 'GET',
	});
